var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-select',{attrs:{"list":_vm.itemsList,"data":_vm.data,"search-is-loading":_vm.isLoading,"label":"Выберите доступные слои","search-label":"Поиск слоев","search":"","chips":"","multiple":""},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }